import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import profil from '../assets/photo_pro.png';
import portfolioData from '../data/portfolioData';

const HeroSection: React.FC = () => (
  <section id="home" className="hero">
    <div className="container">
      <div className="hero__inner">
        {/* Content */}
        <div className="hero__content">
          <h1 className="hero__name">{portfolioData.identity.name}</h1>
          <p className="hero__tagline">{portfolioData.identity.tagline}</p>
          <p className="hero__description text-justify">{portfolioData.identity.description}</p>

          {/* CTAs */}
          <div className="hero__ctas">
            <a href="#projects" className="btn btn--primary">
              Voir mes projets
              <FaChevronRight size={14} />
            </a>
            <a href="#contact" className="btn btn--secondary">
              Me contacter
            </a>
          </div>

          {/* Badges */}
          <div className="hero__badges">
            <span className="hero__badge hero__badge--green">
              ● Alternance : Septembre 2026
            </span>
            <span className="hero__badge hero__badge--green">
              ● Stage 6 mois : Février 2027
            </span>
            <span className="hero__badge">React</span>
            <span className="hero__badge">Angular</span>
            <span className="hero__badge">TypeScript</span>
            <span className="hero__badge">Node.js</span>
            <span className="hero__badge">Spring Boot</span>
            <span className="hero__badge">Certifié Javascript ES6+</span>
            {/* <span className="hero__badge">Ansible</span> */}
            <span className="hero__badge">Claude Code</span>
            <span className="hero__badge">Codex</span>
          </div>
        </div>

        {/* Photo */}
        <div className="hero__photo">
          <div className="hero__photo-wrapper">
            <img src={profil} alt="Dimitri Bonsou — Développeur Fullstack" />
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="hero__stats">
        {portfolioData.stats.map((stat, index) => (
          <div key={index} className="hero__stat">
            <div className="hero__stat-value">{stat.value}</div>
            <div className="hero__stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HeroSection;
